<template>
  <div class="accordion_group">
    <ul class="accordion_group__item">
      <slot></slot>
    </ul>
  </div>
</template>
<script>
    import SvgImage from '@theme-views/common/SvgIcon/Icons/Image'
    import SvgInfo from '@theme-views/common/SvgIcon/Icons/Info'
    import SvgStar from '@theme-views/common/SvgIcon/Icons/Star'
    import AccordionGroup from '@theme-views/common/AccordionGroup/accordion_group'

    export default {
        mixins: [AccordionGroup],
        components: {
            SvgImage,
            SvgInfo,
            SvgStar,
        }
    }
</script>
<style lang="scss" src="./accordion_group.scss"></style>
